enum CurrencyEnum {
  EUR = 'EUR',
  GBP = 'GBP',
  USD = 'USD',
}

export const allCurrencies = Object.values(CurrencyEnum);

export default CurrencyEnum;
